import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ColumnsLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("rect", { width: 16, height: 5, x: 19, y: 4, stroke: "currentColor", strokeLinejoin: "round", rx: 1, transform: "rotate(90 19 4)" }),
            React.createElement("rect", { width: 16, height: 5, x: 10, y: 4, stroke: "currentColor", strokeLinejoin: "round", rx: 1, transform: "rotate(90 10 4)" })));
}
const ColumnsLight = forwardRef(_ColumnsLight);
export { ColumnsLight };
